import React, { FC } from 'react'
import styled from 'styled-components'
import { HeadingXS } from 'uiComponents/atoms/Text/Headings'

const Headline = styled(HeadingXS)`
  margin: 20px 24px 0 24px;
`
const SimpleHeadline: FC<{ title: string }> = ({ title }) => {
  return <Headline data-testid={`FilterHeadline_${title}`}>{title}</Headline>
}

export default SimpleHeadline
